import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BootConstants } from '../boot.constants';
import { IChangePassword } from '../interfaces/IChangePassword';
import { map } from 'rxjs/operators';
;

@Injectable()
export class UserRepository {

    constructor(private tokenHttp: TokenHttp) { }

    public changePassword(passwordChange: IChangePassword): Observable<any> {
        return this.tokenHttp.put(BootConstants.apiServiceEndpoint + "user/changePassword", passwordChange)
        .pipe(map((res: Response) => res.arrayBuffer().byteLength > 0 ? res.json() : {}));
    }


}